import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Grid,
  CircularProgress, Alert,
} from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import { httpClient } from "../../api/httpClient";
import { API_ORIGIN } from "../../api/config";

const GeocodeTool = () => {
  const [query, setQuery] = React.useState("");
  const [result, setResult] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const handleSearch = async () => {
    if (!query.trim()) return;
    setLoading(true);
    setResult(null);
    try {
      const { json } = await httpClient(
        // Monté hors du préfixe /api/v1 : GET /api/geocode/autocomplete?q=…
        `${API_ORIGIN}/api/geocode/autocomplete?q=${encodeURIComponent(query)}`
      );
      setResult(json);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <PlaceIcon /> Géocode
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Suggestions d'adresses (avec latitude/longitude) via GET /api/geocode/autocomplete.
      </Alert>
      <Card>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={8}>
              <TextField
                fullWidth size="small"
                label="Adresse à géocoder"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="ex: 10 rue de la Paix, Paris"
              />
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={handleSearch} disabled={loading || !query.trim()}>
                {loading ? <CircularProgress size={20} /> : "Chercher"}
              </Button>
            </Grid>
          </Grid>
          {result && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6">Résultat</Typography>
              <Box component="pre" sx={{
                bgcolor: "#f5f7fa", p: 2, borderRadius: 1,
                fontFamily: "monospace", fontSize: 13, mt: 1,
                maxHeight: 400, overflow: "auto",
              }}>
                {JSON.stringify(result, null, 2)}
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: GeocodeTool };
